import { Component, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material";
import { MessageService } from '../../services/message.service';
import { ConfirmationDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { AddNotificationComponent } from './add-notification/add-notification.component';
import { NotificationsService } from 'src/services/notifications.service';

@Component({
  selector: 'app-manage-notifications',
  templateUrl: './manage-notifications.component.html',
  styleUrls: ['./manage-notifications.component.css']
})
export class ManageNotificationsComponent implements OnInit {

  columns: any[] = [
    { name: "subject", displayName: "Title" },
    { name: "messageTpl", displayName: "Message", actionable: false },
    { name: "sentOn", displayName: "Sent On", type: 'date', format: "DD/MM/YYYY h:mma" },
    { name: "usersCount", displayName: "Users", actionable: false },
    { name: "actions", type: "actions", displayName: "Actions" }
  ];
  data: any[];
  notificationsList: any[] = [];
  isReadOnly: boolean = false;
  bookmarks: any[] = [];
  role: any;
  searchTxt: string = '';
  searchByText: boolean = false;
  totalCount: number = 5;
  pageSize: number = 5;
  labels: any;
  title: any;
  page: any;

  constructor(
    private dialog: MatDialog,
    private msgService: MessageService,
    private notificationService: NotificationsService
  ) { }

  ngOnInit() {
    this.getNotifications();
  }

  onActionClicked(e) {
    var viewRec = e.record;
    // console.log(viewRec);

    switch (e.actionName.name) {

      case "search":
        const dialogRefView = this.dialog.open(AddNotificationComponent, {
          width: "525px",
          data: {
            rec: viewRec,
            title: 'Notification Detail'
          }
        });
        dialogRefView.afterClosed().subscribe(result => {
          //  this.getNotifications();
        });
        break;
      case "edit":
        var rec = viewRec;
        const dialogRefEdit = this.dialog.open(AddNotificationComponent, {
          width: "660px",
          data: {
            rec,
            title: 'Edit Notification'
          }
        });
        dialogRefEdit.afterClosed().subscribe(result => {
          if (result === 'updated') {
            if (this.searchTxt !== '') {
              this.applyFilter();
            } else {
              this.getNotifications();
            }
            this.msgService.showSuccess(this.msgService.notificationUpdate);
          }
        });
        break;
      case "delete":
        const dialogRefDelete = this.dialog.open(ConfirmationDialogComponent, {
          width: "450px",
          data: {
            message: 'Are you sure you want to delete this notification?'
          }
        });
        dialogRefDelete.afterClosed().subscribe(result => {
          if (result === 'yes') {
            this.notificationService.deleteNotification(viewRec.id).subscribe(
              (response: any[]) => {
                if (this.searchTxt !== '') {
                  this.applyFilter();
                } else {
                  this.getNotifications();
                }
                this.msgService.showSuccess(this.msgService.notificationDelete);
              },
              error => {
                console.log("Service error:");
              }
            );
          } else {
          }
        });
        break;
      case "send":
        this.processSendingNotification(viewRec);
        break;
      case "restart_alt":
        this.processSendingNotification(viewRec);
        break;
      default:
        console.log("Unhandled actionable: ", e.actionName);
    }
  }

  getNotifications() {
    this.notificationService.getNotifications().subscribe(
      (response: any) => {
        this.notificationsList = response.data;
        this.notificationsList.forEach(item => {
          if (item.sentOn === undefined) {
            item['actions'] = [
              { name: 'edit', tip: 'Edit Notification' },
              { name: 'delete', tip: 'Delete Notification' },
              { name: 'send', tip: 'Send Notification' }
            ];
          } else {
            item['actions'] = [
              { name: 'search', tip: 'View Notification' },
              { name: 'restart_alt', tip: 'Resend Notification' }
            ];
          }
        });
        // console.log("response", response);
      }, err => {
        console.log('error', err);
      });
  }

  add(data: any) {
    const dialogRef = this.dialog.open(AddNotificationComponent, {
      width: "660px",
      // height:"300px",
      data: { title: "Add Notification" },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'updated') {
        this.searchTxt = '';
        this.getNotifications();
        this.msgService.showSuccess(this.msgService.notificationCreate);
      }
    });
  }

  processSendingNotification(rec) {
    const dialogRefSend = this.dialog.open(ConfirmationDialogComponent, {
      width: "450px",
      data: {
        message: 'Are you sure you want to send this notification?'
      }
    });
    dialogRefSend.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.notificationService.sendNotification(rec).subscribe((response: any) => {
          if (this.searchTxt !== '') {
            this.applyFilter();
          } else {
            this.getNotifications();
          }
        this.msgService.showSuccess(this.msgService.notificationSent);
        }, err => {
          console.log('error', err);
        });
      }
    });
  }

  applyFilter() {
    console.log(this.searchTxt);
    if (this.searchTxt !== '') {
      this.searchByText = true;
      this.notificationService.getFilteredNotificationList(this.searchTxt).subscribe((response: any) => {
        this.notificationsList = response.data;
        this.notificationsList.forEach(item => {
          if (item.sentOn === undefined) {
            item['actions'] = [
              { name: 'edit', tip: 'Edit Notification' },
              { name: 'delete', tip: 'Delete Notification' },
              { name: 'send', tip: 'Send Notification' }
            ];
          } else {
            item['actions'] = [{ name: 'search', tip: 'View Notification' }];
          }
        });
      });
    } else {
      this.searchByText = false;
      this.getNotifications();
    }
  }

  clear() {
    this.searchTxt = "";
    this.applyFilter();
  }

  onPageChanged(page) {
    this.pageSize = page.pageSize;
    this.page = page;
  }
}
